import ResourceTrendMinMax from "./resource-trend-minmax"
import { resourceTrendStore } from "./resource-trend-store"
import { Fragment } from "react"
import { RESOURCE_TREND_CARDS } from "@/constants/resource-const"
import { langStore } from "@/stores/lang-store"
import Flex from "@/components/flex"
import ResourceTrendMiniChart from "./resource-trend-mini-chart"
import { overviewStore } from "../../overview-store"
import useIsMobile from "@/hooks/use-is-mobile"
import { kpiMetricStore } from "../kpi-metric/kpi-metric-store"
import { trendBundle } from "./resource-trend-const"
import Wrapper from "@/components/wrapper"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"

const ResourceTrendView = () => {
  const { lang } = langStore()
  const isMobile = useIsMobile()
  const { trendMap } = resourceTrendStore()
  const { kpiMap } = kpiMetricStore() // KPI 스토어의 데이터 활용
  const { selectedTab } = overviewStore()

  // KPI 데이터를 기반으로 현재 탭의 사용하지 않는 항목(value === 0) 체크
  const currentKpiItems = kpiMap?.[selectedTab.id] || []
  const zeroKeyMap = currentKpiItems.reduce((acc, cur) => {
    acc[cur.key] = cur.value === 0
    return acc
  }, {})

  // RESOURCE_TREND_CARDS를 value가 0인 항목이 뒤로 가도록 정렬
  const { heat_type } = aptSearchStore((s) => s.pickApt)
  const sortedTrendCards =
    heat_type === 1
      ? RESOURCE_TREND_CARDS.filter((m) => !["hotwater", "hot"].includes(m.key))
      : RESOURCE_TREND_CARDS

  return (
    <Wrapper.shadow className="p-5 flex flex-col gap-4 bg-white rounded-2xl">
      <Flex className="justify-between">
        <div className="flex items-center gap-1">
          <h2 className="text-lg font-bold text-gray-800">
            {selectedTab.id === "today"
              ? trendBundle.title.today[lang]
              : trendBundle.title.trend[lang]}
          </h2>
          <span className="text-gray-400 text-xs cursor-pointer">ⓘ</span>
        </div>
      </Flex>

      <div className="flex flex-col md:flex-row gap-5">
        {sortedTrendCards.length > 0 &&
          sortedTrendCards.map((item, idx) => {
            const isDisabled = zeroKeyMap[item.key] ?? false

            return (
              <Fragment key={item.key}>
                {idx !== 0 && (
                  <div className="hidden md:block shrink-0">
                    <div className="w-px h-full bg-gray-200" />
                  </div>
                )}
                <div
                  className={`flex flex-col w-full min-w-40 transition-opacity ${
                    isDisabled ? "opacity-40 grayscale pointer-events-none" : ""
                  }`}
                >
                  <div className="px-1 py-2 mb-0 md:mb-4">
                    <p className="flex gap-1 items-center text-md font-semibold text-gray-700 mb-5 -ml-1.5">
                      <img
                        src={item.imgSrc}
                        alt={item.label[lang]}
                        className="w-6 h-6 object-contain"
                      />
                      {item.label[lang]} {trendBundle.usage[lang]}
                      <span className="text-xs text-gray-400 mt-1">
                        ({trendMap?.[selectedTab.id]?.[item.key]?.unit})
                      </span>
                    </p>
                    {!isMobile && (
                      <ResourceTrendMinMax trends={trendMap[selectedTab.id]} item={item} />
                    )}
                  </div>
                  <Flex gap={24}>
                    <ResourceTrendMiniChart
                      color={item.color}
                      min={trendMap[selectedTab.id]?.[item.key]?.min?.value}
                      max={trendMap[selectedTab.id]?.[item.key]?.max?.value}
                      xAxisLabels={trendMap?.[selectedTab.id]?.[item.key]?.labels || []}
                      data={trendMap?.[selectedTab.id]?.[item.key]?.values || []}
                      unit={trendMap?.[selectedTab.id]?.[item.key]?.unit || ""}
                    />
                    {isMobile && (
                      <ResourceTrendMinMax trends={trendMap[selectedTab.id]} item={item} />
                    )}
                  </Flex>
                </div>
              </Fragment>
            )
          })}
      </div>
    </Wrapper.shadow>
  )
}

export default ResourceTrendView
